<div class="filter" matRipple (click)="clickedTag()">
  <mat-icon *ngIf="filterItem.icon" class="icon">
    {{ filterItem.icon }}
  </mat-icon>
  <span *ngIf="filterItem.filterTypeTranslateKey" class="title">
    {{ filterItem.filterTypeTranslateKey | translate }}:
  </span>
  <span class="value" *ngIf="filterItem.displayName">
    {{ filterItem.displayName }}
  </span>
  <span class="value" *ngIf="filterItem.displayName$">
    {{ filterItem.displayName$ | async }}
  </span>
  <button mat-icon-button (click)="removeTag($event)" *ngIf="!hideDelete">
    <mat-icon>cancel</mat-icon>
  </button>
  <button mat-icon-button *ngIf="hideDelete">
    <mat-icon>create</mat-icon>
  </button>
</div>
